import { Button, Table as ChakraTable } from "@chakra-ui/react";
import GenericTable from "@/components/GenericTable";
import GenericTableElement from "@/components/GenericTableElement";
import { formatCalendarDate } from "../../contracts/columns";
import { formatDocument } from "../../screenings/columns";
import { CLAIM_TABLE_COLUMNS, formatPeriods } from "../columns";
import { Claim } from "../types";
import StatusBadge from "./StatusBadge";

const COLUMNS = [
  ...CLAIM_TABLE_COLUMNS,
  { key: "actions", label: "", width: "1fr", minWidth: 120 },
];

type Props = {
  isLoading: boolean;
  claims: Claim[];
  onSelect: (claim: Claim) => void;
  onDismiss: (claim: Claim) => void;
};

const Table = ({
  isLoading,
  claims,
  onSelect,
  onDismiss,
}: Props): JSX.Element => (
  <GenericTable isLoading={isLoading} columns={COLUMNS} interactive size="sm">
    {claims.map((claim) => (
      <ChakraTable.Row
        key={claim.id}
        cursor="pointer"
        onClick={() => onSelect(claim)}
      >
        <GenericTableElement value={claim.contractNumber} />
        <GenericTableElement value={formatDocument(claim)} />
        <GenericTableElement value={claim.tenantName} />
        <GenericTableElement value={formatPeriods(claim.reportedPeriods)} />
        <GenericTableElement value={claim.amount} formatNumber />
        <GenericTableElement value={formatCalendarDate(claim.createdAt)} />
        <GenericTableElement
          value={claim.status}
          actions={<StatusBadge status={claim.status} />}
        />
        <ChakraTable.Cell textAlign="end">
          {claim.status === "reported" && (
            <Button
              size="xs"
              variant="outline"
              onClick={(event) => {
                event.stopPropagation();
                onDismiss(claim);
              }}
            >
              Desistir
            </Button>
          )}
        </ChakraTable.Cell>
      </ChakraTable.Row>
    ))}
  </GenericTable>
);

export default Table;
